// extracted by mini-css-extract-plugin
module.exports = {"section":"blog-banner-module--section--3sSkP","wrapper":"blog-banner-module--wrapper--2_59W","button":"blog-banner-module--button--1WrFL"};